import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography, Avatar, LinearProgress } from '@mui/material';
import DashboardLayout from '../Sidebar/DashboardLayout';
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';
import BusinessIcon from '@mui/icons-material/Business';
import GroupIcon from '@mui/icons-material/Group';
import axios from 'axios';
import './Dashboard.css';
import Chatbox from '../../commun/ChatBox';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const userName = localStorage.getItem('userType') || 'Utilisateur';
  const userRole = localStorage.getItem('userType');

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/dashboard/stats`);
        setStats(res.data);
      } catch (error) {
        console.error("Erreur de chargement des données :", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  return (
    <DashboardLayout>
      <div className="dashboard-wrapper">
        <Typography variant="h4" className="dashboard-heading">
          Bienvenue {userName} <span className="wave">👋</span>
        </Typography>

        {loading ? (
          <LinearProgress className="dashboard-loader" />
        ) : (
          <Grid container spacing={3}>
            <StatCard
              icon={<BusinessIcon />}
              title="Entreprises"
              value={stats?.entreprises || 0}
              color="blue"
            />
            <StatCard
              icon={<GroupIcon />}
              title="Recruteurs"
              value={stats?.recruteurs || 0}
              color="purple"
            />
            <StatCard
              icon={<PeopleIcon />}
              title="Candidats"
              value={stats?.candidats || 0}
              color="green"
            />
            <StatCard
              icon={<WorkIcon />}
              title="Missions"
              value={stats?.missions || 0}
              color="orange"
            />
          </Grid>
        )}
      </div>
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}

    </DashboardLayout>
  );
};

const StatCard = ({ icon, title, value, color }) => (
  <Grid item xs={12} sm={6} md={3}>
    <Paper className={`stat-card stat-${color}`} elevation={3}>
      <div className="stat-card-content">
        <Avatar className="stat-icon">{icon}</Avatar>
        <div>
          <Typography className="stat-title">{title}</Typography>
          <Typography className="stat-value">{value}</Typography>
        </div>
      </div>
    </Paper>
  </Grid>
);

export default Dashboard;
